import { api } from "@/api/client"
import type { PublicLegalDocument } from "@/types/personalDocument"

export async function fetchPublicDocument(
  slug: string
): Promise<PublicLegalDocument> {
  const { data } = await api.get<PublicLegalDocument>(`/public/documents/${slug}`)
  return data
}
